"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFeatureFlag = exports.setFeatureFlagFeature = exports.initFeatureFlagPublic = exports.initSelfFeatureFlag = exports.initFeatureFlag = exports.getFeatureFlag = exports.setFeatureFlag = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const featureFlagKey = 'featureFlag';
const featureFlagKeyPublic = 'featureFlagPublic';
let featureFlagStorage = new web_ui_framework_1.FeatureFlagStorage();
const setFeatureFlag = (value) => {
    featureFlagStorage.setFeatureFlag(value);
};
exports.setFeatureFlag = setFeatureFlag;
const getFeatureFlag = () => {
    return featureFlagStorage.getFeatureFlag() || new Map();
};
exports.getFeatureFlag = getFeatureFlag;
const initFeatureFlag = async (params, API) => {
    const urlBuilder = new web_ui_framework_1.UrlBuilder({
        featureFlag: `${params.featureFlagServiceHost}/v1/feature-flags`,
    });
    const featureFlagService = new web_ui_framework_1.FeatureFlagApiService({
        urlBuilder,
        xhr: API,
        urlKey: featureFlagKey,
    });
    const { bank, platform, staticFeatureFlags } = params;
    if (staticFeatureFlags) {
        const flagsMap = new Map(staticFeatureFlags.map(obj => [obj.flagName, obj.isEnabled]));
        featureFlagStorage.setFeatureFlag(flagsMap);
        return flagsMap;
    }
    const value = await featureFlagService.exec({ bank, platform });
    featureFlagStorage.setFeatureFlag(value);
    return value;
};
exports.initFeatureFlag = initFeatureFlag;
const initSelfFeatureFlag = async (params, API) => {
    const urlBuilder = new web_ui_framework_1.UrlBuilder({
        featureFlag: `${params.featureFlagServiceHost}/v1/feature-flags`,
    });
    const featureFlagService = new web_ui_framework_1.FeatureFlagApiService({
        urlBuilder,
        xhr: API,
        urlKey: featureFlagKey,
    });
    const { bank, platform, staticFeatureFlags } = params;
    const featureFlagStorageSelf = new web_ui_framework_1.FeatureFlagStorage();
    if (staticFeatureFlags) {
        const flagsMap = new Map(staticFeatureFlags.map(obj => [obj.flagName, obj.isEnabled]));
        featureFlagStorageSelf.setFeatureFlag(flagsMap);
        return { featureFlagStorage: featureFlagStorageSelf };
    }
    const value = await featureFlagService.exec({ bank, platform });
    featureFlagStorageSelf.setFeatureFlag(value);
    (0, exports.setFeatureFlagFeature)(featureFlagStorageSelf);
    return { featureFlagStorage: featureFlagStorageSelf };
};
exports.initSelfFeatureFlag = initSelfFeatureFlag;
const initFeatureFlagPublic = async (params, API) => {
    const urlBuilder = new web_ui_framework_1.UrlBuilder({
        featureFlagPublic: `${params.featureFlagServiceHost}/v1/ce944fac55ceed47a1db07090614c7fd/feature-flags`,
    });
    const featureFlagService = new web_ui_framework_1.FeatureFlagApiService({
        urlBuilder,
        xhr: API,
        urlKey: featureFlagKeyPublic,
    });
    const { bank, platform, staticFeatureFlags } = params;
    if (staticFeatureFlags) {
        const flagsMap = new Map(staticFeatureFlags.map(featureFlag => [featureFlag.flagName, featureFlag.isEnabled]));
        featureFlagStorage.setFeatureFlag(flagsMap);
        return flagsMap;
    }
    const value = await featureFlagService.exec({ bank, platform });
    featureFlagStorage.setFeatureFlag(value);
    return value;
};
exports.initFeatureFlagPublic = initFeatureFlagPublic;
const setFeatureFlagFeature = (_featureFlagStorage) => {
    featureFlagStorage = _featureFlagStorage;
};
exports.setFeatureFlagFeature = setFeatureFlagFeature;
const checkFeatureFlag = key => {
    const featureFlagValues = featureFlagStorage.getFeatureFlag();
    if (!featureFlagValues) {
        return false;
    }
    return featureFlagStorage.canI(key);
};
exports.checkFeatureFlag = checkFeatureFlag;
//# sourceMappingURL=featureFlag.js.map